exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-9b9c214e]{background-color:#fff!important}.white[data-v-9b9c214e]{background-color:#a56836!important;color:#fff;text-shadow:1px 1px #000}.details[data-v-9b9c214e]{font-size:.8rem}.meal-name[data-v-9b9c214e]{font-size:20px}.price[data-v-9b9c214e]{font-size:18px;text-align:right}.py[data-v-9b9c214e]{padding:5px 0 5px 10px}.row[data-v-9b9c214e]{margin-left:unset!important;margin-right:unset!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b9c214e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/karte/KarteItem.vue
// module id = 66
// module chunks = 0